<template>
    <div class="promotionListSetting">
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{ setTingObj.titleShow.title }}</span>
                <SwitchButton :value="setTingObj.titleShow"></SwitchButton>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.opriceShow.title }}</span>
                <SwitchButton :value="setTingObj.opriceShow"></SwitchButton>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.priceShow.title }}</span>
                <SwitchButton :value="setTingObj.priceShow"></SwitchButton>
            </div>
<!--            <div class='headerSerc-item'>-->
<!--                <span>{{ setTingObj.couponShow.title }}</span>-->
<!--                <SwitchButton :value="setTingObj.couponShow"></SwitchButton>-->
<!--            </div>-->
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.fontColor.title}}</span>
                <color :colorObj="setTingObj.fontColor"></color>
            </div>
        </div>
    </div>
</template>
<script>
    import tab from '@/components/decoration/common/tab.vue';
    import SwitchButton from '@/components/decoration/common/switchButton.vue';
    import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
    import color from '@/components/decoration/common/color.vue';

    export default {
        components: { color, sliderAndInput, SwitchButton, tab },
        data(){
            return{
                status: 'content'
            }
        },
        props: {
            setTingObj: {
                type: Object,
                default: {}
            }
        },
        methods:{
            getTab(e){
                this.status = e
            },
        }
    }
</script>
<style scoped lang="scss">

</style>